export default "__VITE_ASSET__B3KA95EV__"